import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';

export const authGuard: CanActivateFn = (
  route,
  state
): Observable<boolean | UrlTree> => {

  const afAuth = inject(AngularFireAuth);
  const router = inject(Router);

  return afAuth.authState.pipe(
    map(user => {
      if (user) {
        return true;
      } else {
        return router.createUrlTree(['/']);
      }
    })
  );
};
